import React from 'react';
import { Button, Grid, GridSize } from '@mui/material';
import { SelectOption } from '../../shared/model';
import FormInput from '../../shared/form/FormInput';
import SelectInput from '../../shared/form/SelectInput';
import { UsersContext } from '../contexts/UsersContext';

export interface FilterProps {
  label: string;
  pluralLabel: string;
  selector: string;
  width: boolean | GridSize;
  type: string;
  optionSelector: string;
  options?: SelectOption[];
}

interface UserFilterBarProps {
  filters?: FilterProps[];
  filterValues?: any;
  setFilterValues?: any;
  filterChoices?: any;
}

const UserFilterBar: React.FC<UserFilterBarProps> = (props) => {
  const { filters, filterValues, setFilterValues, filterChoices } = props;

  const { fetchUsers, users, usersLoading } = React.useContext(UsersContext);

  const convertFilters = () => {
    return Object.entries(filterValues)
      .map(([key, value]) => (value !== 'status__all' ? `${key}=${value}&` : ''))
      .join('');
  };

  const handleApplyFilters = async () => {
    const filterParam = convertFilters();
    fetchUsers(filterParam);
  };

  const handleFiltersKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      handleApplyFilters();
    }
  };

  return (
    <Grid container spacing={1} alignItems="flex-start" onKeyDown={handleFiltersKeyPress}>
      <Grid item xs={12} md={2}>
        <FormInput
          value={filterValues?.full_name}
          onChange={(value) => setFilterValues({ ...filterValues, full_name: value })}
          label="Full Name"
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <FormInput
          value={filterValues?.email_address}
          onChange={(value) => setFilterValues({ ...filterValues, email_address: value })}
          label="Email"
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <FormInput
          value={filterValues?.company__name}
          onChange={(value) => setFilterValues({ ...filterValues, company__name: value })}
          label="Company"
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <SelectInput
          value={filterValues?.status}
          onChange={(value) => setFilterValues({ ...filterValues, status: value })}
          label="Status"
          defaultChoice={{ label: 'All', value: 'status__all' }}
          choices={[
            { label: 'Active', value: 'true' },
            { label: 'Inactive', value: 'false' },
          ]}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <Button
          variant="contained"
          color="primary"
          style={{ color: '#fff', marginTop: 19 }}
          disableElevation
          onClick={() => {
            handleApplyFilters();
          }}
        >
          Apply
        </Button>
      </Grid>
    </Grid>
  );
};

export default UserFilterBar;
